/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconZodiacGemini = createReactComponent("zodiac-gemini", "IconZodiacGemini", [
  ["path", { d: "M3 3a21 21 0 0 0 18 0", key: "svg-0" }],
  ["path", { d: "M3 21a21 21 0 0 1 18 0", key: "svg-1" }],
  ["path", { d: "M7 4.5l0 15", key: "svg-2" }],
  ["path", { d: "M17 4.5l0 15", key: "svg-3" }]
]);

export { IconZodiacGemini as default };
//# sourceMappingURL=IconZodiacGemini.js.map
